import React from 'react';
import { motion } from 'framer-motion';
import logo from '../logo.png';
import phoneImage from '../phone.png';
import './Home.css';

const Home = () => {
  const features = [
    {
      icon: '⚡',
      title: 'Rezervare Rapidă',
      description: 'Rezervă-ți cursa în câteva secunde cu interfața noastră intuitivă'
    },
    {
      icon: '💳',
      title: 'Plăți Securizate',
      description: 'Multiple opțiuni de plată cu securitate de nivel bancar'
    },
    {
      icon: '🗺️',
      title: 'Urmărire în Timp Real',
      description: 'Urmărește șoferul în timp real cu GPS precis'
    },
    {
      icon: '⭐',
      title: 'Șoferi de Top',
      description: 'Șoferi profesioniști și verificați la serviciul tău'
    },
    {
      icon: '💬',
      title: 'Suport 24/7',
      description: 'Suport clienți non-stop pentru nevoile tale'
    },
    {
      icon: '🎯',
      title: 'Cele Mai Bune Rute',
      description: 'Optimizare de traseu cu inteligență artificială pentru călătorii mai rapide'
    }
  ];

  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-bg">
          <div className="orb orb-1"></div>
          <div className="orb orb-2"></div>
          <div className="orb orb-3"></div>
        </div>

        <div className="container hero-content">
          <motion.div
            className="hero-text"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1>
              Taxi în Suceava,
              <br />
              <span className="gradient-text">Direct din Telefon</span>
            </h1>
            <p>
              Comandă taxi, plătește cu cardul, vezi unde e șoferul.
              Simplu și rapid.
            </p>

            <div className="hero-buttons">
              <motion.a
                href="#download"
                className="primary-btn"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Descarcă Acum
              </motion.a>
              <motion.a
                href="tel:0744511111"
                className="phone-btn"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                📞 0744 511 111
              </motion.a>
              <motion.a
                href="tel:0230511111"
                className="phone-btn"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                📞 0230 511 111
              </motion.a>
            </div>
          </motion.div>

          <motion.div
            className="hero-image"
            initial={{ opacity: 0, x: 100 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <img src={phoneImage} alt="suceava.taxi App" className="phone-screenshot" />
          </motion.div>
        </div>
      </section>

      {/* Features Section */}
      <section id="features" className="features">
        <div className="container">
          <motion.div
            className="section-header"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2>
              De Ce <span className="gradient-text">suceava.taxi</span>
            </h2>
            <p>Descoperă diferența cu funcționalitățile noastre de ultimă generație</p>
          </motion.div>

          <div className="features-grid">
            {features.map((feature, index) => (
              <motion.div
                key={index}
                className="feature-card"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                whileHover={{ y: -10 }}
              >
                <div className="feature-icon">{feature.icon}</div>
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Download Section */}
      <section id="download" className="download">
        <div className="container">
          <motion.div
            className="download-content"
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2>Începe Astăzi</h2>
            <p>Descarcă suceava.taxi acum și bucură-te de prima ta cursă cu oferte speciale</p>

            <div className="download-buttons">
              <motion.a
                href="https://apps.apple.com"
                className="store-btn"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="store-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
                  </svg>
                </div>
                <div className="store-text">
                  <span className="small">Descarcă pe</span>
                  <span className="large">App Store</span>
                </div>
              </motion.a>

              <motion.a
                href="https://play.google.com"
                className="store-btn"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="store-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z"/>
                  </svg>
                </div>
                <div className="store-text">
                  <span className="small">Disponibil pe</span>
                  <span className="large">Google Play</span>
                </div>
              </motion.a>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-logo">
              <img src={logo} alt="suceava.taxi" className="footer-logo-img" />
            </div>
            <div className="footer-links">
              <a href="tel:0744511111">📞 0744 511 111</a>
              <a href="tel:0230511111">📞 0230 511 111</a>
              <a href="/terms">Termeni și Condiții</a>
              <a href="/privacy">Politica de Confidențialitate</a>
              <a href="mailto:contact@suceava.taxi">Contact</a>
            </div>
            <p className="copyright">© 2024 Euro Taxi SRL. Toate drepturile rezervate.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Home;
